import { requireNativeViewManager } from 'expo-modules-core';

export default requireNativeViewManager('ExpoVideoView');
